let url = window.location.protocol + "//" + window.location.host;

if (process.env.MOBILE_APP) {
  url = (localStorage || {}).getItem('api_url');
}

module.exports = {
  url,
  isDev: window.location.hostname === 'localhost',
};
